import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=488ef295&scoped=true&"
import script from "./scope.vue?vue&type=script&lang=js&"
export * from "./scope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ef295",
  null
  
)

export default component.exports